<template>
	<div>
		<sui-modal v-model="open" size="fullscreen">
			<sui-modal-header>
				<slot name="titulo">
					<strong class="blackFont"
						>{{ editar ? 'Editar' : 'Crear' }} pregunta</strong
					>
				</slot>
				<i
					style="float: right; cursor: pointer;"
					class="close icon"
					@click="close"
				></i>
			</sui-modal-header>
			<sui-modal-content scrolling>
				<sui-modal-description>
					<sui-form @submit.prevent>
						<div class="ui two column grid">
							<div class="column">
								<BaseInput
									v-model="pregunta.clave"
									titulo="Clave"
									placeholder="Clave"
									class="field"
									type="text"
									:error="erroresValidacion && !validationClave"
									:disabled="editar"
								></BaseInput>
								<sui-form-fields>
									<BaseTextArea
										v-model="pregunta.contenido"
										titulo="Contenido"
										placeholder="Contenido"
										:rows="
											pregunta.contenido
												? pregunta.contenido.split('\n').length
												: 1
										"
										:error="erroresValidacion && !validationContenido"
										class="mini sixteen wide field"
									></BaseTextArea>
									<div class="field">
										<button
											v-puede="[roles.Administrador]"
											class="ui compact icon primary button "
											title="Agregar imagen"
											@click.prevent="toggleModalArchivo"
										>
											<i class="image icon"></i>
										</button>
									</div>
								</sui-form-fields>
								<label class="boldFont">Respuestas</label>
								<div
									v-for="(respuesta, index) in pregunta.respuestas"
									:key="`respuesta-${index}`"
									style="margin: .5em;"
								>
									<div class="ui compact segment" style="width: 100%;">
										<div class="fields" style="margin: 0 !important;">
											<div class="two wide field">
												<div class="ui radio checkbox" style="width: 100%;">
													<input
														:id="`pregunta-${index}`"
														type="radio"
														name="pregunta-respuesta"
														:value="respuesta.opcion"
														:checked="
															respuesta.opcion === pregunta.respuestaCorrecta
																? 'checked'
																: ''
														"
														title="Correcta"
														@input="
															pregunta.respuestaCorrecta = $event.target.value
														"
													/>
													<label :for="`pregunta-${index}`"></label>
												</div>
											</div>
											<div class="two wide field">
												<BaseInput
													v-model="respuesta.opcion"
													sin-titulo
													:error="
														erroresValidacion &&
															!validationOpcionRespuesta(respuesta)
													"
													placeholder="Opción"
													class="mini"
												></BaseInput>
											</div>
											<div class="ten wide field">
												<BaseTextArea
													v-model="respuesta.contenido"
													titulo="Respuesta"
													placeholder="Respuesta"
													:error="
														erroresValidacion &&
															!validationContenidoRespuesta(respuesta)
													"
													:rows="
														respuesta.contenido
															? respuesta.contenido.split('\n').length
															: 1
													"
													class="mini"
													sin-titulo
												></BaseTextArea>
											</div>
											<div class="two wide field">
												<button
													class="ui icon button red boldFont mini basic right floated"
													@click="onRemoveRespuesta(index)"
												>
													<i class="trash icon"></i>
												</button>
											</div>
										</div>
									</div>
								</div>
								<div style="margin-top: 5px;">
									<span
										v-show="erroresValidacion && !validationRespuestas"
										style="color: #9f2241 !important;"
									>
										<sui-icon name="exclamation circle" />Es necesario más de
										una respuesta a la pregunta.
									</span>
								</div>
								<div style="margin: .5em;">
									<a href="#" @click.prevent="onNuevaRespuesta">
										<div class="ui compact segment" style="width: 100%;">
											<h4 class="ui header">
												<i class="plus icon"></i>
												<div class="content">Agregar respuesta</div>
											</h4>
										</div>
									</a>
								</div>
							</div>
							<div class="column">
								<h4>Previsualización</h4>
								<label>
									<base-mostrar-markdown
										style="display: inline-block;"
										:agregado="`**${pregunta.clave}.**`"
										:contenido="pregunta.contenido"
									/>
								</label>
								<template
									v-for="(respuesta, keyRespuesta) in pregunta.respuestas"
								>
									<div :key="`respuesta-${keyRespuesta}`" style="padding: 1em;">
										<div class="field">
											<div class="ui radio checkbox">
												<input
													:id="`pregunta-${keyRespuesta}`"
													type="radio"
													name="pregunta"
													:value="respuesta.opcion"
													:checked="
														respuesta.opcion === pregunta.respuestaCorrecta
															? 'checked'
															: ''
													"
													@input="
														pregunta.respuestaCorrecta = $event.target.value
													"
												/>
												<label
													:key="`respuesta-${keyRespuesta}`"
													:for="`pregunta-${keyRespuesta}`"
													style="cursor: pointer;"
												>
													<base-mostrar-markdown
														:agregado="`**${respuesta.opcion}** **)** `"
														:contenido="respuesta.contenido"
													/>
												</label>
											</div>
										</div>
									</div>
								</template>
							</div>
						</div>
						<base-button
							class="boldFont submit"
							style-button="primary"
							style-class="right floated"
							:loading="loading"
							type="submit"
							@click.native="toggle"
							>Guardar</base-button
						>
					</sui-form>
				</sui-modal-description>
			</sui-modal-content>
		</sui-modal>
		<BaseModalArchivo
			ref="modal-archivo"
			v-model="files"
			titulo="Subir imagen"
			acepta=".jpeg"
			:loading="loadingImagen"
			:tamanio="0.025"
			error-tamanio="El archivo excede el tamaño permitido. Máximo 25KB."
			@close="toggleModalArchivo"
			@aceptar="subirArchivos"
		/>
	</div>
</template>
<script>
import _ from 'lodash';
import { mapGetters, mapMutations } from 'vuex';

import Vue from 'vue';
import roles from '@constants/roles.js';

export default {
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		editar: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			open: false,
			pregunta: {
				clave: '',
				contenido: '',
				respuestaCorrecta: '',
				respuestas: [
					{ opcion: 'A', contenido: '' },
					{ opcion: 'B', contenido: '' },
					{ opcion: 'C', contenido: '' },
					{ opcion: 'D', contenido: '' }
				]
			},
			erroresValidacion: false,
			roles,
			files: [],
			loadingImagen: false
		};
	},
	computed: {
		...mapGetters('bancosDePreguntas', ['getPregunta']),
		validationClave() {
			return (
				this.pregunta.clave !== undefined && this.pregunta.clave.trim() !== ''
			);
		},
		validationContenido() {
			return (
				this.pregunta.contenido !== undefined &&
				this.pregunta.contenido.trim() !== ''
			);
		},
		validationRespuestas() {
			return (
				this.pregunta.respuestas != null && this.pregunta.respuestas.length > 1
			);
		}
	},
	watch: {
		open(val) {
			if (!val) {
				this.erroresValidacion = false;
				this.SET_PREGUNTA({
					clave: '',
					contenido: '',
					respuestaCorrecta: '',
					respuestas: [
						{ opcion: 'A', contenido: '' },
						{ opcion: 'B', contenido: '' },
						{ opcion: 'C', contenido: '' },
						{ opcion: 'D', contenido: '' }
					]
				});
				this.$emit('input', {});
			}
		},
		getPregunta(val) {
			if (!_.isEmpty(val) && this.editar) {
				this.pregunta = {
					clave: val.clave || '',
					contenido: val.contenido || '',
					respuestaCorrecta: val.respuestaCorrecta || '',
					respuestas: val.respuestas || []
				};
				this.$emit('input', this.pregunta);
			} else {
				this.pregunta = {
					clave: '',
					contenido: '',
					respuestaCorrecta: '',
					respuestas: [
						{ opcion: 'A', contenido: '' },
						{ opcion: 'B', contenido: '' },
						{ opcion: 'C', contenido: '' },
						{ opcion: 'D', contenido: '' }
					]
				};
			}
		}
	},
	mounted() {},
	methods: {
		...mapMutations('bancosDePreguntas', ['SET_PREGUNTA']),
		toggle($event) {
			event.preventDefault();
			if (this.open) {
				if (
					this.validationClave &&
					this.validationContenido &&
					this.validationRespuestas
				) {
					this.erroresValidacion = false;
					this.$emit('input', this.pregunta);
					if (this.editar) {
						this.$emit('editar');
					} else {
						this.$emit('guardar');
					}
				} else {
					this.erroresValidacion = true;
				}
			} else {
				this.open = !this.open;
			}
		},
		close() {
			this.open = false;
		},
		aceptar() {},
		validationContenidoRespuesta(respuesta) {
			return (
				respuesta.contenido !== undefined && respuesta.contenido.trim() !== ''
			);
		},
		validationOpcionRespuesta(respuesta) {
			return respuesta.opcion !== undefined && respuesta.opcion.trim() !== '';
		},
		onRemoveRespuesta(indexOpcion) {
			Vue.set(this.pregunta, 'respuestas', [
				...this.pregunta.respuestas.filter((x, index) => index !== indexOpcion)
			]);
		},
		onNuevaRespuesta() {
			Vue.set(this.pregunta, 'respuestas', [
				...this.pregunta.respuestas,
				{ opcion: '', contenido: '' }
			]);
		},
		toggleModalArchivo() {
			this.$refs['modal-archivo'].toggle();
		},
		closeModalArchivo() {
			this.$refs['modal-archivo'].close();
		},
		subirArchivos() {
			this.loadingImagen = true;
			const image = this.files[0];
			this.getBase64Image(image, (result) => {
				this.loadingImagen = false;
				this.pregunta.contenido = `${this.pregunta.contenido}\n> ![](${result})`;
				this.closeModalArchivo();
			});
		},
		getBase64Image(img, callback) {
			var reader = new FileReader();
			reader.onloadend = function() {
				callback(reader.result);
			};
			reader.readAsDataURL(img);
		}
	}
};
</script>

<style lang="scss" module>
@import '@design';
.danger {
	color: $background-danger;
}
</style>
